/** Keep Authorization under typical edge limits (~8KB). */
export const MAX_SEERIST_API_KEY_CHARS = 4096;

/**
 * Normalize pasted Seerist keys (Bearer prefix, quotes, multi-line email
 * dumps). Mirrors seerist-playground / COMS seeristClient.normalizeApiKey.
 */
export function normalizeSeeristApiKey(raw: unknown): string {
  let key = String(raw ?? '').trim();
  if (!key) return '';

  if (/\r?\n/.test(key)) {
    const lines = key
      .split(/\r?\n/)
      .map((line) =>
        line
          .trim()
          .replace(/^Bearer\s+/i, '')
          .replace(/^['"]|['"]$/g, '')
      )
      .filter(Boolean);
    const tokenLine = [...lines]
      .reverse()
      .find((line) => line.length >= 16 && !/\s/.test(line));
    key = tokenLine || lines[lines.length - 1] || '';
  }

  return key
    .replace(/^Bearer\s+/i, '')
    .replace(/^['"]|['"]$/g, '')
    .trim();
}
